function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 1C7.435 1 3.75 4.559 3.75 8.967c0 5.46 7.37 13.467 7.706 13.79a.732.732 0 001.088 0c.335-.323 7.706-8.33 7.706-13.79C20.25 4.599 16.523 1 12 1z",
  fill: "#FF6C0E"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.212 10.931c-.04-.033-.113-.033-.113-.033s-.033-.099-.13-.131c-.04-.017-.073-.017-.097-.017-.017 0-.025.017-.017.033 0 .016.008.033.017.05.008.008.016.024.032.032.049.041.073.025.114.041.032.009.04.033.04.033s-.008-.016-.04-.024c-.009 0-.025-.008-.033-.008-.032 0-.065 0-.097-.034a.063.063 0 01-.033-.032s-.008-.009-.008 0c-.016 0-.024.008-.016.024a.154.154 0 00.065.058.22.22 0 00.097.016c.025.009.04.025.04.025l-.015.033c-.009.025-.009.05-.009.05s-.267-.091-.47-.149c-.34-.107-.584.149-.738.33-.267.329-.462.255-.527.23-.008 0-.024 0-.024.017 0 .008 0 .016.008.016.195.124.381.066.665-.148.17-.132.268-.124.268-.124 0 .215.113.173.13.38a.466.466 0 01-.074.27c-.016.026-.008.05.017.075.064.066.235.23.227.346 0 .008.008.016.016.016l.04.017c.016.008.04-.008.04-.033a.492.492 0 00-.105-.247c-.105-.14-.097-.206-.008-.305.073-.082.154-.148.179-.296a.32.32 0 00-.073-.264c.024.017.065.05.089.107.024.058.024.116.024.116.057 0 .13-.025.17-.033.017-.009.033.008.025.024a.189.189 0 01-.081.107c-.008.009-.017.017-.017.033l-.008.041c0 .017.017.033.033.025a.34.34 0 00.122-.107.56.56 0 00.056-.14.166.166 0 01.033-.066c.024-.024.056-.066.113-.115.025-.025.146.008.179-.008.016-.017.032-.066.032-.066-.016-.017-.081-.115-.138-.165z",
  fill: "#FFF0E7"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.889 15H17M14.778 15h.476M13.349 11.19h1.27",
  stroke: "#FFF0E7",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.35 5.714h5.952M15.889 5.714h-.635",
  stroke: "#FFF0E7",
  strokeWidth: 0.5,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.286 14.286v-5m-8.572 0v3.571M7 14.286h10m-7.679-3.929h2.322v2.5H8.786v-1.964m3.928 3.393v-3.393a.535.535 0 01.536-.536h1.429a.536.536 0 01.535.536v3.393m-7.5-.794v.794M15.214 5h-6.23c-.337 0-.397.159-.69.68L7.096 7.79c-.325.71.215 1.515 1.053 1.54h.045c.7 0 1.269-.244 1.269-.848 0 .603.568.848 1.27.848.7 0 1.267-.204 1.267-.848 0 .603.568.848 1.269.848.7 0 1.27-.204 1.27-.848 0 .644.567.848 1.268.848h.044c.838-.026 1.379-.83 1.053-1.54l-.966-2.11c-.19-.412-.237-.68-.724-.68z",
  stroke: "#FFF0E7",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgMarkerDropOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}
export default __webpack_public_path__ + "/img/markerDropOff.svg";
export { SvgMarkerDropOff as ReactComponent };